export const cmsApis = {
    financeApi: '/v1/F2044',   //获取财经日历数据
    newsListApi: '/v1/F203',   //获取新闻列表
    fastListApi: '/v1/F203',   //获取市场快讯列表
    hotNewsApi: '/v1/F208',     //热点新闻
    hotNewaDetailApi: '/v1/F209',//热点新闻详情
    // --------------------抽奖相关------------------
    drawApi: '/userlotteryinfo/lottery',//抽奖
    searchTurntable: '/turntable/findall',//查询转盘
    drawNumberApi: '/turntablenumstatus/selectlotteryinfo',//抽奖次数
    drawHistory: 'turntablelog/findall',//抽奖记录
    paidUrl: 'findall'
    
}

